/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_No_Limit_Chip_TooltipInputs */



/**
* | output |
* | --- |
* | "Removes the cap. Overage spending continues until you set one again." |
*
* @param {Usage_Overage_No_Limit_Chip_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_no_limit_chip_tooltip = /** @type {((inputs?: Usage_Overage_No_Limit_Chip_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_No_Limit_Chip_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernt das Limit. Überschuss-Ausgaben laufen weiter, bis Sie wieder eines setzen.")
	return /** @type {LocalizedString} */ ("Removes the cap. Overage spending continues until you set one again.")
});